export const sortSlaves = (slaves) => {
    return slaves.sort(({ phone: phone1 }, { phone: phone2 }) => {
        return Number(phone2) - Number(phone1);
    });
};
